import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { getStaPage } from "@/api/api-operation-service";
import { piUtSaveStorage } from "@/utils/utils";
import selectStation from "@/components/select-station/select-station.vue";
import PiExport from "@/components/pi-export/pi-export.vue";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import piNameTooltip from "@/components/pi-name-tooltip/pi-name-tooltip.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
let PiPileInfo = class PiPileInfo extends mixins(tableMaxHeight) {
    constructor() {
        super(...arguments);
        this.formInline = {
            oprPkId: "",
            globalSearch: "",
            globalPageIndex: 1,
            globalPageSize: 10,
        };
        this.loading = false;
        this.privilegeVoObj = {};
        this.total = 0;
        this.exportCondition = {};
        this.staStatusObj = {
            0: "",
            1: "primary",
            5: "",
            6: "warning",
            50: "success",
        };
        this.tableList = [];
        this.tableColumns = [];
        this.allTableData = [
            {
                title: i18n.t("operatorId"),
                key: "operatorId",
                minWidth: 110,
            },
            {
                title: i18n.t("commonTableName.staPkId"),
                key: "staPkId",
                minWidth: 130,
            },
            {
                title: i18n.t("commonTableName.staName"),
                key: "staName",
                slot: "staName",
                ...this.$config.tableName,
            },
            {
                title: i18n.t("pileInfoDetail.staAddress"),
                key: "staAddress",
                ...this.$config.tableName,
            },
            {
                title: i18n.t("commonTableName.staType"),
                key: "staTypeName",
                minWidth: 120,
            },
            {
                title: i18n.t("commonTableName.staStatus"),
                key: "staStatusName",
                minWidth: 120,
                slot: "staStatusName",
            },
            {
                title: i18n.t("operation"),
                slot: "action",
                width: 100,
            },
        ];
    }
    tableChange(val) {
        this.formInline.globalPageIndex = val;
        this.getTableList();
    }
    tableSizeChange(val) {
        this.formInline.globalPageSize = val;
        this.getTableList();
    }
    async getTableList() {
        this.loading = true;
        const ret = await getStaPage(this.formInline);
        if (ret.status == this["$config"].apiStatus) {
            this.tableList = ret.data;
            this.total = ret.total;
        }
        this.loading = false;
    }
    onClickSearch() {
        this.formInline.globalPageIndex = 1;
        this.exportCondition = Object.assign({}, this.formInline);
        this.getTableList();
    }
    detailClick(item) {
        this.$router.push("/pile-manage/pile-info/detail?staPkId=" + item.staPkId);
    }
    bindPileList(item) {
        piUtSaveStorage("pile-info-item", item); // 存在本地
        this.$router.push("/pile-manage/pile-list?staPkId=" + item.staPkId);
    }
    mounted() {
        this.privilegeVoObj = this.$common.getPrivilegeVoObj(this.$route);
    }
    activated() {
        if (this.tableList.length == 0) {
            // 刚进来或者无数据
            this.getTableList();
        }
        else if (this.$pageChildren.getSuccess("pile-info")) {
            // 有数据并在子页面操作了之后要刷新
            this.getTableList();
        }
    }
};
PiPileInfo = __decorate([
    Component({
        components: {
            selectStation,
            PiExport,
            piSelectTableData,
            "pi-name-tooltip": piNameTooltip,
        },
    })
], PiPileInfo);
export default PiPileInfo;
